import type { QueryClient } from "@-/com.npmjs.tanstack__react-query";
import {
  bootstrapActorSyncForSignIn,
  markSignUpForGuestReplay,
} from "@-/dev.improve.haniverse.lib.sync-client";
import { setDeviceSetting } from "@-/dev.improve.haniverse.lib.device-settings";

/** Complete an already-confirmed social session without waiting for account data. */
export function finishGetStartedSocialSignIn(queryClient: QueryClient, email: string): void {
  // Keep this device's local study when connecting a provider after offline email entry.
  // The explicit guest-replay hint also survives an already-provisioned cloud database.
  markSignUpForGuestReplay();
  setDeviceSetting("hasDismissedFirstLevelAccountPrompt", true);
  // The provider's address is the account's now, replacing any address recorded earlier. Set
  // before leaving so the app gate already sees it.
  setDeviceSetting("accountEmail", email);
  // Auth succeeds independently of connectivity; the existing sync recovery handles failures.
  void bootstrapActorSyncForSignIn(queryClient).catch(() => {});
}
